import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Bell } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

/** Candidate Portal alerts for newly assigned tasks (existing in-app notifications). */
export function PortalBell({ goTo }) {
  const [d, setD] = useState({ items: [], unread: 0 });
  const load = () => api.get("/portal/notifications").then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);
  const open = async (n) => {
    if (!n.read) { await api.post(`/portal/notifications/${n.id}/read`).catch(() => {}); load(); }
    goTo("tasks", null, n.task_ids?.length === 1 ? { taskId: n.task_ids[0] } : {});
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="relative rounded-md p-2 hover:bg-white/10" aria-label="Notifications" data-testid="portal-bell">
          <Bell className="w-5 h-5" />
          {d.unread > 0 && <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] rounded-full bg-amber-400 text-[11px] font-bold text-slate-900 grid place-items-center" data-testid="portal-bell-count">{d.unread}</span>}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 bg-white">
        {!d.items.length && <p className="px-3 py-4 text-sm text-slate-500">No new task alerts.</p>}
        {d.items.map((n) => (
          <DropdownMenuItem key={n.id} onClick={() => open(n)} className="flex flex-col items-start gap-0.5 py-2 cursor-pointer" data-testid={`portal-notif-${n.id}`}>
            <span className={`text-sm ${n.read ? "text-slate-500" : "font-semibold text-slate-900"}`}>{n.title}</span>
            {n.task_ids?.length > 1 && <span className="text-xs text-slate-500 line-clamp-2">{n.body}</span>}
            <span className="text-[11px] text-slate-400">{new Date(n.created_at).toLocaleString()}{n.by_name ? ` · from ${n.by_name}` : ""}</span>
          </DropdownMenuItem>))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
